module.exports = __webpack_public_path__ + "img/banner.c676bda8.png";